import React, { createContext, useContext, useState } from 'react';
import es from './es';
import en from './en';

const translations = { es, en };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(
        localStorage.getItem('language') || 'es'
    );

    const toggleLanguage = () => {
        const next = language === 'es' ? 'en' : 'es';
        setLanguage(next);
        localStorage.setItem('language', next);
    };

    // Permite establecer un idioma específico (p. ej. desde un dropdown)
    const changeLanguage = (lang) => {
        if (!translations[lang]) return;
        setLanguage(lang);
        localStorage.setItem('language', lang);
    };

    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];
        for (const k of keys) {
            value = value?.[k];
        }

        return value || key;
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, changeLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}
